var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusWithCircle = function SvgPlusWithCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    x: 0.5,
    y: 0.5,
    fill: "currentColor",
    rx: 13.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007AFF",
    d: "M7.5 14c0 .482.396.87.87.87h4.76v4.76c0 .474.396.87.87.87s.87-.396.87-.87v-4.76h4.76c.474 0 .87-.388.87-.87a.88.88 0 0 0-.87-.87h-4.76V8.37A.88.88 0 0 0 14 7.5a.88.88 0 0 0-.87.87v4.76H8.37a.88.88 0 0 0-.87.87"
  })));
};
export default SvgPlusWithCircle;